import { Component } from '@angular/core';

@Component({
    selector: 'app-social-twitter',
    templateUrl: './social-twitter.component.html',
    standalone: false
})
export class SocialTwitterComponent {
}
